import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/mobile/close.png';
import _imports_1 from '../assets/mobile/jiahao.png';
const _withScopeId = n => (_pushScopeId("data-v-04a9bb1c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "body"
};
const _hoisted_2 = {
  key: 0,
  class: "footer"
};
const _hoisted_3 = {
  class: "footer-top"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  class: "logo"
};
const _hoisted_6 = {
  alt: "钧舵机器人"
};
const _hoisted_7 = {
  class: "companyTel"
};
const _hoisted_8 = {
  key: 0,
  class: "label"
};
const _hoisted_9 = {
  key: 1,
  class: "label"
};
const _hoisted_10 = {
  key: 2,
  class: "label"
};
const _hoisted_11 = {
  key: 3,
  class: "label"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "toPhoneStyle",
  href: "tel:0512-63025073"
}, "0512-63025073")], -1));
const _hoisted_13 = {
  class: "saleTel"
};
const _hoisted_14 = {
  key: 0,
  class: "label"
};
const _hoisted_15 = {
  key: 1,
  class: "label"
};
const _hoisted_16 = {
  key: 2,
  class: "label"
};
const _hoisted_17 = {
  key: 3,
  class: "label"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "toPhoneStyle",
  href: "tel:0512-63667858"
}, "0512-63667858")], -1));
const _hoisted_19 = {
  key: 4,
  class: "label"
};
const _hoisted_20 = {
  key: 6,
  class: "label"
};
const _hoisted_21 = {
  key: 8,
  class: "label"
};
const _hoisted_22 = {
  key: 10,
  class: "label"
};
const _hoisted_23 = {
  class: "footer-icon"
};
const _hoisted_24 = {
  alt: "facebook"
};
const _hoisted_25 = {
  style: {
    "width": "100%",
    "height": "100%"
  },
  alt: "youtube"
};
const _hoisted_26 = {
  alt: "x.com"
};
const _hoisted_27 = {
  class: "right"
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  class: "list"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
  class: "modebox"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = {
  class: "list"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  key: 0,
  class: "beian"
};
const _hoisted_36 = {
  key: 1,
  class: "beian"
};
const _hoisted_37 = {
  key: 2,
  class: "beian"
};
const _hoisted_38 = {
  key: 3,
  class: "beian"
};
const _hoisted_39 = {
  key: 1,
  class: "footerAreaMb"
};
const _hoisted_40 = {
  class: "footerMb"
};
const _hoisted_41 = {
  class: "leftAreaMb"
};
const _hoisted_42 = {
  class: "logoMb"
};
const _hoisted_43 = {
  alt: ""
};
const _hoisted_44 = {
  key: 0,
  class: "bottomMb"
};
const _hoisted_45 = {
  key: 1,
  class: "bottomMb"
};
const _hoisted_46 = {
  key: 2,
  class: "bottomMb"
};
const _hoisted_47 = {
  key: 3,
  class: "bottomMb"
};
const _hoisted_48 = {
  class: "rightAreaMb"
};
const _hoisted_49 = {
  class: "companyTel"
};
const _hoisted_50 = {
  key: 0,
  class: "label"
};
const _hoisted_51 = {
  key: 1,
  class: "label"
};
const _hoisted_52 = {
  key: 2,
  class: "label"
};
const _hoisted_53 = {
  key: 3,
  class: "label"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content mb"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "toPhoneStyle",
  href: "tel:0512-63025073"
}, "0512-63025073")], -1));
const _hoisted_55 = {
  class: "saleTel"
};
const _hoisted_56 = {
  key: 0,
  class: "label"
};
const _hoisted_57 = {
  key: 1,
  class: "label"
};
const _hoisted_58 = {
  key: 2,
  class: "label"
};
const _hoisted_59 = {
  key: 3,
  class: "label"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "toPhoneStyle",
  href: "tel:0512-63667858"
}, "0512-63667858")], -1));
const _hoisted_61 = {
  key: 4,
  class: "content last"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "tel:18962472921",
  class: "toPhoneStyle"
}, "18962472921", -1));
const _hoisted_63 = [_hoisted_62];
const _hoisted_64 = {
  key: 5,
  class: "label"
};
const _hoisted_65 = {
  key: 7,
  class: "label"
};
const _hoisted_66 = {
  key: 9,
  class: "label"
};
const _hoisted_67 = {
  class: "footer-icon"
};
const _hoisted_68 = {
  alt: ""
};
const _hoisted_69 = {
  alt: ""
};
const _hoisted_70 = {
  alt: ""
};
const _hoisted_71 = {
  class: "listAreaMb"
};
const _hoisted_72 = {
  class: "iconMb"
};
const _hoisted_73 = ["onClick"];
const _hoisted_74 = {
  key: 0,
  class: "iconImgMb"
};
const _hoisted_75 = {
  key: 0,
  src: _imports_0,
  alt: "关闭"
};
const _hoisted_76 = {
  key: 1,
  src: _imports_1,
  alt: "+"
};
const _hoisted_77 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_el_collapse = _resolveComponent("el-collapse");
  const _directive_img_lazy = _resolveDirective("img-lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$setup.ispc ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_directive_img_lazy, $setup.language == 'en' ? $setup.footerLogoEn : $setup.footerLogo]])]), _createElementVNode("div", _hoisted_7, [$setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_8, "公司电话:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Company phone:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_10, "TEL:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_11, "회사 전화:")) : _createCommentVNode("", true), _hoisted_12]), _createElementVNode("div", _hoisted_13, [$setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_14, "销售热线:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Sales phone:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_16, "ホットライン:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_17, "판매문의 전화:")) : _createCommentVNode("", true), _hoisted_18, $setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_19, "电子邮箱:")) : _createCommentVNode("", true), $setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", {
    key: 5,
    class: "content last",
    onClick: _cache[0] || (_cache[0] = $event => $setup.toEmail())
  }, " sales@jodell.cn ")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Email:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", {
    key: 7,
    class: "content last",
    onClick: _cache[1] || (_cache[1] = $event => $setup.toEmail())
  }, " sales@jodell.cn ")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_21, "メールボックス:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", {
    key: 9,
    class: "content last",
    onClick: _cache[2] || (_cache[2] = $event => $setup.toEmail())
  }, " sales@jodell.cn ")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_22, "메일박스:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", {
    key: 11,
    class: "content last",
    onClick: _cache[3] || (_cache[3] = $event => $setup.toEmail())
  }, " sales@jodell.cn ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
    class: "footer-iconbox",
    onClick: _cache[4] || (_cache[4] = $event => $setup.toWebsites('https://www.facebook.com/profile.php?id=61557411657588'))
  }, [_withDirectives(_createElementVNode("img", _hoisted_24, null, 512), [[_directive_img_lazy, $setup.footerIcon1]])]), _createElementVNode("div", {
    class: "footer-iconbox icon-margin",
    onClick: _cache[5] || (_cache[5] = $event => $setup.toWebsites('https://www.youtube.com/@JodellRobotics'))
  }, [_withDirectives(_createElementVNode("img", _hoisted_25, null, 512), [[_directive_img_lazy, $setup.footerIcon2]])]), _createElementVNode("div", {
    class: "footer-iconbox",
    onClick: _cache[6] || (_cache[6] = $event => $setup.toWebsites('https://x.com/Jodell_Robotics'))
  }, [_withDirectives(_createElementVNode("img", _hoisted_26, null, 512), [[_directive_img_lazy, $setup.footerIcon3]])])])]), _createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newNavList1, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mode",
      key: index
    }, [_createElementVNode("div", {
      class: "title",
      onClick: $event => $setup.chooseNav(item.navPath)
    }, _toDisplayString(item.navName), 9, _hoisted_28), _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.navChild, item1 => {
      return _openBlock(), _createElementBlock("div", {
        key: item1.id,
        class: "item",
        onClick: $event => $setup.chooseChildNav(item.navPath, item.navChildPath, item1.id)
      }, _toDisplayString(item1.shName ? item1.shName + item1.navName : item1.navName), 9, _hoisted_30);
    }), 128))])]);
  }), 128)), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newNavList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mode",
      key: index
    }, [_createElementVNode("div", {
      class: "title",
      style: {
        "margin-bottom": "0px"
      },
      onClick: $event => $setup.chooseNav(item.navPath)
    }, _toDisplayString(item.navName), 9, _hoisted_32), _createElementVNode("div", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.navChild, item1 => {
      return _openBlock(), _createElementBlock("div", {
        key: item1.id,
        class: "item",
        onClick: $event => $setup.chooseChildNav(item.navPath, item.navChildPath, item1.id)
      }, _toDisplayString(item1.shName ? item1.shName + item1.navName : item1.navName), 9, _hoisted_34);
    }), 128))])]);
  }), 128))])])]), $setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_35, " copyright（©）2022. 苏州钧舵机器人有限公司 苏ICP备18070625号-1 ")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_36, " copyright（©）2022. Suzhou Jodell Robotics Ltd. Co. 苏ICP备18070625号-1 ")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_37, " copyright（©）2022. 蘇州Jodell Robotics株式会社 苏ICP备18070625号-1 ")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_38, " copyright（©）2022. 쑤저우 조델 로보틱스 유한회사 苏ICP备18070625号-1 ")) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_withDirectives(_createElementVNode("img", _hoisted_43, null, 512), [[_directive_img_lazy, $setup.language == 'en' ? $setup.footerLogoEn : $setup.footerLogo]])]), $setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_44, " 全国代理商火热招募中… ")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_45, " Sincerely looking for agents across the world… ")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_46, " 全国各地の代理店を熱烈に募集中… ")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_47, " 글로벌 에이전트를 열렬히 찾고 있습니다… ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [$setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_50, "公司电话:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_51, "Company phone:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_52, "TEL:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_53, "회사 전화:")) : _createCommentVNode("", true), _hoisted_54]), _createElementVNode("div", _hoisted_55, [$setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_56, "销售热线:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_57, "Sales phone:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_58, "ホットライン:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_59, "판매문의 전화:")) : _createCommentVNode("", true), _hoisted_60, $setup.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_61, _hoisted_63)) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_64, "Email:")) : _createCommentVNode("", true), $setup.language == 'en' ? (_openBlock(), _createElementBlock("div", {
    key: 6,
    class: "content last",
    onClick: _cache[7] || (_cache[7] = $event => $setup.toEmail())
  }, " sales@jodell.cn ")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_65, "メールボックス:")) : _createCommentVNode("", true), $setup.language == 'jp' ? (_openBlock(), _createElementBlock("div", {
    key: 8,
    class: "content last",
    onClick: _cache[8] || (_cache[8] = $event => $setup.toEmail())
  }, " sales@jodell.cn ")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_66, "메일박스:")) : _createCommentVNode("", true), $setup.language == 'kr' ? (_openBlock(), _createElementBlock("div", {
    key: 10,
    class: "content last",
    onClick: _cache[9] || (_cache[9] = $event => $setup.toEmail())
  }, " sales@jodell.cn ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", {
    class: "footer-iconbox",
    onClick: _cache[10] || (_cache[10] = $event => $setup.toWebsites('https://www.facebook.com/profile.php?id=61557411657588'))
  }, [_withDirectives(_createElementVNode("img", _hoisted_68, null, 512), [[_directive_img_lazy, $setup.footerIcon1]])]), _createElementVNode("div", {
    class: "footer-iconbox icon-margin",
    onClick: _cache[11] || (_cache[11] = $event => $setup.toWebsites('https://www.youtube.com/@JodellRobotics'))
  }, [_withDirectives(_createElementVNode("img", _hoisted_69, null, 512), [[_directive_img_lazy, $setup.footerIcon2]])]), _createElementVNode("div", {
    class: "footer-iconbox",
    onClick: _cache[12] || (_cache[12] = $event => $setup.toWebsites('https://x.com/Jodell_Robotics'))
  }, [_withDirectives(_createElementVNode("img", _hoisted_70, null, 512), [[_directive_img_lazy, $setup.footerIcon3]])])])])]), _createElementVNode("div", _hoisted_71, [_createVNode(_component_el_collapse, {
    class: "listMb",
    accordion: "",
    modelValue: $setup.activeName,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $setup.activeName = $event),
    onChange: $setup.handleChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navlistMb, (item, index) => {
      return _openBlock(), _createBlock(_component_el_collapse_item, {
        name: index,
        class: "navMb",
        key: index,
        disabled: item.navChild.length === 0
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_72, [_createElementVNode("span", {
          style: {
            "height": "100%",
            "display": "inline-block"
          },
          onClick: $event => $setup.chooseNavMb($event, item.navPath)
        }, _toDisplayString(item.navName), 9, _hoisted_73), item.navChild.length !== 0 ? (_openBlock(), _createElementBlock("span", _hoisted_74, [$setup.activeName == index ? (_openBlock(), _createElementBlock("img", _hoisted_75)) : (_openBlock(), _createElementBlock("img", _hoisted_76))])) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.navChild, item1 => {
          return _openBlock(), _createElementBlock("div", {
            key: item1.id,
            class: "itemMb",
            onClick: $event => $setup.chooseChildNav(item.navPath, item.navChildPath, item1.id)
          }, _toDisplayString(item1.shName ? item1.shName + item1.navName : item1.navName), 9, _hoisted_77);
        }), 128))]),
        _: 2
      }, 1032, ["name", "disabled"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])])]))]);
}